import React, { useMemo, useState } from "react";
import { usePosts } from "../../hooks/useCms";
import { slugToCountryPathname, wordEllipsis } from "../../utils/strings";
import ContainerCard from "./containerCard";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";
import { Link } from "react-router-dom";

export function BlogCard({ content, position }) {
  return (
    <Link to={slugToCountryPathname(content.slug)} className={`articleCardLink ${position === 0 ? "margin" : ""}`}>
      <ContainerCard>
        <div className="articleCardV4">
          <div className="image">
            <LazyLoadImage src={content.header?.heroImage?.formats?.small?.url} alt="Speedoc article" effect="blur" />
          </div>
          <div className="content">
            <div className="filterTags">
              {content?.filterTags?.map((item, index) => (
                <div key={index} className="category">
                  {item.tag.toUpperCase()}
                </div>
              ))}
            </div>
            <div className="headline">{wordEllipsis(content.title, 50)}</div>
            {position === 0 && <p className="textBody">{wordEllipsis(content.meta?.seo?.description, 280)}</p>}
            <div className="publicationDate">{moment(content.publicationDate).format("DD MMM YYYY").toUpperCase()}</div>
          </div>
        </div>
      </ContainerCard>
    </Link>
  );
}

export default function BlogCardsHeader({ content }) {
  const posts = usePosts({ limit: 5 });
  const [arr0, setArr0] = useState([]);
  const [arr1, setArr1] = useState([]);

  useMemo(
    () =>
      (posts || []).forEach((entry, i) => {
        if (i === 0) {
          setArr0(entry);
        } else {
          setArr1(posts.slice(1, 5));
        }
      }),
    [posts]
  );

  return (
    <div id="blogCardsHeader">
      <div className="header">{content.title}</div>
      <div className="description">{content.description}</div>
      <div className="cardsHeaderSection">
        <div className="firstCard">
          <BlogCard content={arr0} position={0} />
        </div>
        <div className="otherCards">
          {arr1 &&
            arr1.length &&
            arr1.map((entry, index) => <BlogCard key={index} content={entry} position={index + 1} />)}
        </div>
      </div>
    </div>
  );
}
